import React from 'react';

interface Props {
  amount: number;
  decimalPlaces?: number;
}

const NumberFormatter = ({ amount, decimalPlaces }: Props) => {
  const getFormattedPrice = (amount: number, decimalPlaces?: number) => {
    if (amount !== undefined) {
      let formatter = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: decimalPlaces !== undefined ? decimalPlaces : 0,
        minimumFractionDigits: decimalPlaces !== undefined ? decimalPlaces : 0
      });
  
      return formatter.format(amount);
    }
  };

  return <>{getFormattedPrice(amount, decimalPlaces)}</>;
}

export default NumberFormatter;